import RpcService          		from '@/core/services/Rpc/RpcService';

import type RpcResponse    		from '@/core/services/Rpc/RpcResponse';
import type Lead           		from '@/domains/Leads/Lead';
import type RpcDataPagination from '@/core/services/Rpc/RpcDataPagination';
import type RpcDataSort       from '@/core/services/Rpc/RpcDataSort';


class LeadsDAO {

	static async getList(
		filters?: {
			name?:  string;
			email?: string;
			phone?: string;
		},
		pagination?: RpcDataPagination,
		sort?:       RpcDataSort,
	): Promise<RpcResponse> {
		return await RpcService.makeRequest(
      'leads.getList',
      {
        ...filters,
      },
      pagination,
      sort
    );
	}

	static async add(lead: Lead): Promise<RpcResponse> {
		return await RpcService.makeRequest('leads.add', { lead });
	}

	static async update(lead: Lead): Promise<RpcResponse> {
		return await RpcService.makeRequest('leads.update', { lead });
	}

	static async delete(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('leads.delete', { id });
	}
}

export default LeadsDAO;
